module.exports = __webpack_public_path__ + "static/loviatar-symbol-SCAG-7fc25f74b84e18ae0cfc99f46fbf7d8e.png";